import { getStaticColumnsTotalWidth, WEEKLY_COLUMN_WIDTH } from "./weeklyEACColumns";

// Horizontal scroll offset for a given week. Both Direct Labor's weekly table and the Summary
// table share the same scrollable region, where the static scrollable columns (Account..Apply
// Burden) come first, then each week's own column group — so a week's offset is just the static
// width plus its index times a single week's column width.
export const getWeekScrollOffset = (weekStartDate, weeks, type) => {
  const index = weeks.findIndex((week) => week.weekStartDate === weekStartDate);
  if (index === -1) return null;
  return getStaticColumnsTotalWidth(type) + index * WEEKLY_COLUMN_WIDTH;
};
